import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("{{this.direction}}",{ moduleName: "sh-www/components/lsg/lsg-arrow-button.hbs" })